(function () {
  'use strict';

  angular.module('tf.retailer.Util')
      .factory('activityRegion', ActivityRegionClass);

  function ActivityRegionClass(Activity, BrandReports, Enums) {

    var activities = [];
    var selectedActivity;

    return activityRegion;

    function getSelected() {
      return selectedActivity;
    }

    function defaultLabel(){
      return multipleActivity() ? Enums.TransactionFilterType.Direct : activities[0].label;
    }

    function setSelected(label) {
      selectedActivity = _.find(activities, {label: label});
      return this;
    }

    function getActivities() {
      return activities;
    }

    function multipleActivity() {
      return activities && activities.length > 1;
    }

    function activityRegion(fillFunc, transaction, region) {
      return fillFunc().then(function(filters){
        activities = _.map(filters, function (filter) {
          return Activity(filter);
        });
        if(activities.length) {
          setSelected(transaction ? transaction : defaultLabel());
          selectedActivity.setSelectedRegion(region);
        } else {
          selectedActivity = null;
        }
        return {
          getSelected: getSelected,
          setSelected: setSelected,
          getActivities: getActivities,
          hasMultipleActivity: multipleActivity
        };
      });
    }
  }


})();